import izitoast from 'izitoast';
import 'izitoast/dist/css/iziToast.css';

izitoast.settings({
	progressBar:false,
	position:'topRight',
	pauseOnHover:false,
	closeOnClick:true,
	close:false,
	class:'toast',
});

export default izitoast;